import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import AdminNavBar from "../components/AdminNavBar";

export default function Admin() {
  const navigate = useNavigate();

  const Section: React.FC<{ title: string; children: React.ReactNode }> = ({
    title,
    children,
  }) => (
    <div className="bg-white/90 backdrop-blur-sm rounded-xl p-5 shadow-md border border-gray-200">
      <h2 className="text-lg font-semibold mb-3 text-gray-800">{title}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">{children}</div>
    </div>
  );

  const ButtonLink: React.FC<{ to: string; label: string }> = ({
    to,
    label,
  }) => (
    <Link
      to={to}
      className="block text-center px-4 py-2 rounded-md bg-gray-800 text-white hover:bg-gray-700 transition font-medium shadow-sm"
    >
      {label}
    </Link>
  );

  const LogoutButton: React.FC = () => {
    const handleLogout = () => {
      localStorage.removeItem("token");
      navigate("/login");
    };

    return (
      <button
        type="button"
        onClick={handleLogout}
        className="block w-full text-center px-4 py-2 rounded-md bg-gray-800 text-white hover:bg-red-600 transition font-medium shadow-sm"
      >
        Log Out
      </button>
    );
  };

  return (
    <Layout>
      <AdminNavBar />

      {/* Fractal background wrapper to match other admin pages */}
      <div className="pt-[110px] min-h-screen bg-fractal-pattern-3 bg-cover bg-fixed p-6">
        <div className="max-w-5xl mx-auto space-y-8">
          {/* Title now uses the same dark tone family as the header */}
          <h1 className="text-3xl font-bold text-center text-gray-800 drop-shadow">
            Admin Dashboard
          </h1>

          {/* PUBLIC SITE CONTENT */}
          <Section title="Public Site Content">
            <ButtonLink to="/admin/manage-about-us" label="Manage About Us" />
            <ButtonLink to="/admin/manage-blog" label="Manage Blog" />
            <ButtonLink to="/admin/manage-quotes" label="Manage Quotes" />
          </Section>

          {/* PRODUCTS & LAB RESULTS (backend-facing) */}
          <Section title="Products & Lab Results">
            <ButtonLink to="/admin/manage-products" label="Manage Products" />
            <ButtonLink
              to="/admin/manage-coa"
              label="Manage COA / Test Results"
            />
          </Section>

          {/* EMAIL + SUBSCRIBERS */}
          <Section title="Email & Subscribers">
            <ButtonLink to="/admin/create-update" label="Email Campaigns" />
            <ButtonLink to="/admin/manage-lists" label="Manage Lists" />
            <ButtonLink
              to="/admin/manage-subscribers"
              label="Manage Subscribers"
            />
          </Section>

          {/* ADMIN / USERS */}
          <Section title="Admin Tools">
            <ButtonLink to="/admin/contacts" label="Visitor Contacts" />
            <ButtonLink to="/admin/invite-admin" label="Invite Admin" />
            <ButtonLink
              to="/admin/manage-admin"
              label="Manage Admins / Permissions"
            />
            <LogoutButton />
          </Section>
        </div>
      </div>
    </Layout>
  );
}
